import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'edit-data',
  templateUrl: './edit-data.component.html',
  styleUrls: ['./edit-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )]
})
export class EditDataComponent implements OnInit {
    @Input() dataType: string = 'text';
    @Input() value: string;
    @Output() valueChanged: EventEmitter<string> = new EventEmitter();
    @Output() clickOut: EventEmitter<string> = new EventEmitter();
    initialValue: string;
    showSaveButton: boolean = false;
    showCancelButton: boolean = false;
    @Input() saving: boolean = false;
    unsavedData: boolean = false;
    @Input() canEdit: boolean = false;
    @Input() inputId: string;
    @Input() loading: boolean = false;
    @Input() vertResizeOnly: boolean = false;
    @Input() placeholderText: string = '';

  constructor() { }

  ngOnInit() {
      this.initialValue = this.value;
  }

  cancel() {
      this.value = this.initialValue;
      this.showCancelButton = false;
      this.showSaveButton = false;
      this.unsavedData = false;
  }

  //added to enable two way binding
  // onValueChanged(event){ 
  //     this.valueChanged.emit(event);
  // }

  saveChange(event) {
    console.log("this.value != this.initialValue", this.value , this.initialValue)
      if (this.value != this.initialValue) {
          this.valueChanged.next(this.value);
          this.unsavedData = false;
          this.initialValue = this.value;
          this.showCancelButton = false;
          this.showSaveButton = false;
      }
  }

  onFocus() {
      this.showSaveButton = true;
      this.showCancelButton = true;
  }

  onFocusOut() {
      this.clickOut.next(this.value);
      if (this.initialValue == this.value) {
          this.showSaveButton = false;
          this.showCancelButton = false;
          this.unsavedData = false;
      } else
          this.unsavedData = true;
  }
}
